/* =========================================================================
   HOLY FOREST — GELD

   window.hfGeld(cent) — formatiert einen Centbetrag GENAU so, wie Liquids
   money-Filter es auf derselben Seite tut.

   Warum es diese Datei gibt: es rechnen inzwischen zwei Stellen in
   JavaScript — der Baukasten auf der Startseite (hf-buendel) und die
   Rechenzeile im Kaufbereich (hf-rechner). Beide hatten sonst je eine eigene
   Formatierung. Der erste Versuch im Baukasten war
   Intl.NumberFormat('de-AT') und ergab "€ 127,33" neben Karten, die
   "€74.90" schrieben — zwei Schreibweisen auf einer Flaeche.

   Es gibt deshalb nur eine Quelle: shop.money_format. snippets/hf-craft
   schreibt sie vor dem Laden dieser Datei nach window.hfGeldMuster. Aendert
   Christoph das Format in den Shop-Einstellungen (heute "€{{amount}}",
   richtig waere "{{amount_with_comma_separator}} €"), ziehen alle
   gerechneten Zahlen von selbst mit.

   Die Platzhalternamen sind Shopifys eigene — nicht erfunden, sondern die
   Liste, die der money-Filter kennt.
   ========================================================================= */

(function () {
  var trenne = function (cent, tausend, komma, stellen) {
    var teile = (cent / 100).toFixed(stellen).split('.');
    teile[0] = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, tausend);
    return stellen ? teile.join(komma) : teile[0];
  };

  window.hfGeld = function (cent) {
    var muster = window.hfGeldMuster || '{{amount}}';
    return muster.replace(/\{\{\s*(\w+)\s*\}\}/, function (treffer, name) {
      switch (name) {
        case 'amount_no_decimals': return trenne(cent, ',', '.', 0);
        case 'amount_with_comma_separator': return trenne(cent, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return trenne(cent, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return trenne(cent, "'", '.', 2);
        case 'amount_with_space_separator': return trenne(cent, ' ', ',', 2);
        case 'amount_no_decimals_with_space_separator': return trenne(cent, ' ', ',', 0);
        default: return trenne(cent, ',', '.', 2);
      }
    });
  };
})();
